export default "__VITE_ASSET__D85$kkYx__"